import type { Translations } from "../keys.js";

export const de = {
  eyebrow: "IBKR-Aktivitätsauszug",
  title: "Chance-Risiko-Bericht",
  uploadMark: "Flex XML",
  uploadTitle: "IBKR XML ablegen oder wählen",
  uploadBody: "Name, Konto und Adresse werden lokal maskiert.",
  nfaDisclaimer: "Nur für Lernen und Trade-Review. Keine Finanzberatung.",
  chooseFile: "Datei wählen",
  account: "Konto",
  name: "Name",
  neutralName: "mömö",
  period: "Zeitraum",
  baseCurrency: "Basiswährung",
  closed: "geschlossen",
  executions: "Ausführungen",
  netRealized: "Realisierter Netto-P/L",
  winRate: "Trefferquote",
  payoffRatio: "Payoff-Ratio",
  expectancy: "Erwartungswert",
  executionRecords: "Ausführungen",
  canceledOrders: "Stornierte Orders",
  medianHoldingDays: "Median-Haltedauer",
  commissionDrag: "Provisionen",
  closedTradeSum: "Summe geschlossener Trades",
  grossProfitLoss: "Bruttogewinn / Bruttoverlust",
  averageWinLoss: "Ø Gewinn / Ø Verlust",
  perClosedTrade: "Je geschlossenem Trade",
  flexTradeRecords: "Trade-Datensätze in Flex XML",
  flexCanceledRecords: "Stornierte Order-Datensätze in Flex XML",
  noCanceledRecords: "Keine stornierten Orders im XML",
  holdingReview: "Holding",
  holdingReviewTitle: "Haltedauer- und Payoff-Analyse",
  holdingReviewHint: "Ordnet Eröffnungen und Schließungen zu und vergleicht PF, Payoff und Trefferquote je Haltedauer.",
  holdingPeriod: "Haltedauer",
  holdingIntraday: "Intraday",
  holdingSwing: "1-7 Tage",
  holdingPosition: "8-30 Tage",
  holdingLongTerm: "30+ Tage",
  directionReview: "Direction",
  directionReviewTitle: "Long- / Short-Analyse",
  directionReviewHint: "Teilt geschlossene Trades nach Strategie-Exposure, um die stärkere Seite zu zeigen.",
  longPosition: "Long",
  shortPosition: "Short",
  neutralPosition: "Neutral",
  equityCurve: "Kapitalkurve",
  dailyRealized: "Täglich realisierter P/L",
  payoff: "Payoff",
  winLossDistribution: "Gewinn-/Verlustverteilung",
  periodPerformance: "Periodenleistung",
  periodHint: "Grüne Balken zeigen Gewinn, rote Verlust. PF und Payoff stehen in der Tabelle unten.",
  weekly: "Wöchentlich",
  monthly: "Monatlich",
  periodColumn: "Zeitraum",
  monthColumn: "Monat",
  realized: "Realisiert",
  profitFactor: "Profit Factor",
  pf: "PF",
  payoffShort: "Payoff",
  trades: "Trades",
  assetBreakdown: "Assets",
  assetBreakdownTitle: "Aktien- / Optionsstatistik",
  asset: "Asset",
  medianPnl: "Median-P/L",
  average: "Durchschnitt",
  optionReview: "Optionen",
  optionReviewTitle: "Optionen nach Basiswert",
  underlying: "Basiswert",
  date: "Datum",
  dateCount: "Tage",
  daysShort: "T",
  hoursShort: "Std",
  minutesShort: "Min",
  weakestSession: "Schwächste Sitzung",
  intradaySessionNoData: "Keine Schlüsse in der regulären Sitzung",
  intradaySessionTitle: "Trefferquote: Eröffnung / Mittag / Schluss",
  intradaySessionHint: "Gruppiert Schließungen nach Sitzung und vergleicht Realisiert, Median-P/L, Durchschnitt, PF, Payoff und Trefferquote.",
  weekdayReviewTitle: "Performance nach Wochentag",
  weekdayReviewHint: "Vergleicht reguläre Schließungen und Auto-Verfall nach Wochentag und zeigt die beste und schwächste Payoff-Ratio.",
  weekday: "Wochentag",
  weekdaySunday: "Sonntag",
  weekdayMonday: "Montag",
  weekdayTuesday: "Dienstag",
  weekdayWednesday: "Mittwoch",
  weekdayThursday: "Donnerstag",
  weekdayFriday: "Freitag",
  weekdaySaturday: "Samstag",
  bestDay: "Bester",
  worstDay: "Schwächster",
  session: "Sitzung",
  sessionMorning: "Eröffnung",
  sessionMidday: "Mittag",
  sessionLate: "Schluss",
  autoExpiry: "Auto-Verfall",
  optionLifecycle: "Verfall / Abrechnung",
  optionLifecycleRegularClose: "Regulärer Schluss",
  optionLifecycleEp: "Verfallen",
  optionLifecycleEx: "Ausübung",
  optionLifecycleA: "Zuteilung",
  optionLifecycleCD: "Barausgleich",
  optionLifecycleAEx: "Automatische Ausübung",
  optionLifecycleMEx: "Manuelle Ausübung",
  optionLifecycleGEA: "Verrechnung: Verfall / Zuteilung",
  discipline: "Disziplin",
  disciplineRisk: "Disziplinrisiko",
  largeLossAlert: "Warnung vor großem Verlust",
  largeLossDiscipline: "Erst pausieren. Disziplin schützen.",
  largeLossRule: "Der gesamte Tagesverlust liegt über der aktuellen Risikoschwelle. Erhöhe nicht die Größe, um ihn zurückzuholen, bevor Stop, Tagesverlustlimit und Pausenregel geprüft sind.",
  worstLossDay: "Größter Tagesverlust",
  symbols: "Symbole",
  symbolPerformance: "Symbol-Rangliste",
  page: "Seite",
  previousPage: "Vorherige Seite",
  nextPage: "Nächste Seite",
  offlineCoach: "Offline-Coach",
  offlineAdvice: "Offline-Hinweise",
  bestLoserWins: "Der beste Verlierer gewinnt",
  theme: "Theme",
  language: "Sprache",
  dark: "Dunkel",
  light: "Hell",
  stock: "Aktien",
  option: "Optionen",
  other: "Andere",
  cash: "Bargeld",
  future: "Future",
  unknown: "Unbekannt",
  lossBucketSmall: "Kleiner Verlust",
  lossBucketMedium: "Mittlerer Verlust",
  lossBucketLarge: "Großer Verlust",
  winBucketSmall: "Kleiner Gewinn",
  winBucketMedium: "Mittlerer Gewinn",
  winBucketLarge: "Großer Gewinn",
  chartEmpty: "Keine geschlossenen Trades für das Diagramm",
  dailyChartLegend: "Balken: täglich, Linie: kumuliert",
  periodChartLegend: "PF-Punkte, Ref. 1.00, Obergrenze",
  importFailed: "Import fehlgeschlagen",
  profitStatus: "Gewinn",
  lossStatus: "Verlust",
  flatStatus: "Neutral",
  costStatus: "Kosten",
  toggleDetails: "Details anzeigen",
  "error.invalid_flex_xml": "Lade eine IBKR Flex XML-Datei hoch.",
  "advice.profit_factor_below_one.title": "Der PF liegt unter 1",
  "advice.profit_factor_below_one.body": "Der aktuelle PF beträgt {profitFactor}. Die Gewinne decken die Verluste noch nicht. Reduziere zuerst große Verluste, Verfallverluste und unkontrolliertes Nachlegen, bevor du die Trade-Anzahl erhöhst.",
  "advice.profit_factor_thin_edge.title": "Der PF hat nur wenig Puffer",
  "advice.profit_factor_thin_edge.body": "Der aktuelle PF beträgt {profitFactor}. Das ist handelbar, aber ein oder zwei unkontrollierte Verluste können den ganzen Zeitraum auslöschen. Definiere zuerst Tagesverlust, späteste Ausstiegszeit und Pausenregeln.",
  "advice.profit_factor_healthy.title": "Die PF-Struktur wirkt gesünder",
  "advice.profit_factor_healthy.body": "Der aktuelle PF beträgt {profitFactor}. Erhöhe die Frequenz nicht blind. Finde heraus, welche Symbole, Zeiten und Setups wiederholbar sind, und behalte nur hochwertige Trades.",
  "advice.winrate_and_payoff_weak.title": "Trefferquote und Payoff dürfen nicht beide schwach sein",
  "advice.winrate_and_payoff_weak.body": "Die Trefferquote beträgt {winRate}, der Payoff {payoffRatio}. Weder Trefferquote noch durchschnittlicher Ertrag kompensieren genug. Prüfe vor dem Einstieg Zielraum und Stop-Distanz.",
  "advice.high_winrate_weak_payoff.title": "Die Trefferquote flickt einen schwachen Payoff",
  "advice.high_winrate_weak_payoff.body": "Die Trefferquote beträgt {winRate}, aber der Payoff {payoffRatio}. Ein schlechter Trade kann mehrere gute aufzehren. Das ist meist ein Exit- und Risikodefinitionsproblem, nicht nur Richtung.",
  "advice.overtrade_loss_days.title": "Verlusttage zeigen Beschleunigung",
  "advice.overtrade_loss_days.body": "{days} Tage hatten zugleich viele Trades und negatives PnL. Prüfe Trades nach dem ersten Verlust separat: waren sie noch Teil des Plans oder der Versuch, den Verlust zurückzuholen?",
  "advice.auto_expiry_losses.title": "Auto-Verfallverluste sind kein Rauschen",
  "advice.auto_expiry_losses.body": "{count} Auto-Verfallverluste wurden einbezogen. Verfall auf null ist ein steuerbares Risiko, kein Unfall kurz vor Schluss. Schreibe die späteste akzeptable Ausstiegszeit fest.",
  "advice.good_loser_base.title": "Ein guter Verlierer schützt den nächsten Trade",
  "advice.good_loser_base.body": "Der durchschnittliche Gewinn beträgt {avgWin}, der durchschnittliche Verlust {avgLoss}. Verluste im Plan sind Kosten; Verluste außerhalb des Plans bedeuten, dass Risiko enger definiert werden muss.",
  "advice.detach_outcome_from_ego.title": "Trenne PnL vom Ego",
  "advice.detach_outcome_from_ego.body": "Frage im Review zuerst: Ist dieser Verlust nach Plan passiert? Wenn ja, ist er Kostenpunkt. Wenn nein, ist er ein Disziplinproblem.",
  "advice.large_tail_losses.title": "Verkleinere zuerst die größten Verluste",
  "advice.large_tail_losses.body": "{count} Verluste überschritten {threshold}. Der schnellste Weg zu besserem PF ist oft nicht eine höhere Trefferquote, sondern das Kürzen der Tail-Verluste, die eine ganze Woche zerstören.",
  "advice.asset_group_relative_edge.title": "{stronger} zeigen aktuell einen relativen Vorteil",
  "advice.asset_group_relative_edge.body": "Options-PF ist {optionProfitFactor}; Aktien-PF ist {stockProfitFactor}. Setze Kapital und Aufmerksamkeit dort ein, wo der PF stabiler ist, und prüfe, ob der schwächere Bereich nur Tests oder emotionales Trading war.",
  "advice.option_sample_dominant.title": "Die aktuelle Stichprobe besteht vor allem aus Optionen",
  "advice.option_sample_dominant.body": "Options-PF ist {optionProfitFactor} bei {optionWinRate} Trefferquote. Prüfe Verfall, Ausübung/Zuteilung, Entscheidungen in der letzten Sitzung und IV-Veränderungen separat.",
  "advice.stock_sample_dominant.title": "Die aktuelle Stichprobe besteht vor allem aus Aktien",
  "advice.stock_sample_dominant.body": "Aktien-PF ist {stockProfitFactor} bei {stockWinRate} Trefferquote. Prüfe Haltedauer, Stop-Konsistenz und hinterherlaufende Einstiege, bevor du Aktien mit Optionen mischst.",
  "advice.weak_option_underlying_days.title": "Schwache Options-Symboltage separat prüfen",
  "advice.weak_option_underlying_days.body": "{rows}. Diese Kombinationen liegen näher am echten Entscheidungskontext als die Übersichtstabelle. Prüfe zuerst Richtung, Einstiegszeit und Nähe zum Verfall.",
  "advice.clean_sample.title": "Halte die Stichprobe sauber",
  "advice.clean_sample.body": "Keine einzelne Asset-Gruppe zieht das Ergebnis klar nach unten. Sammle weiter saubere geschlossene Trades und prüfe danach Zyklik, Symbolkonzentration und Setup-Stabilität.",
} satisfies Translations;
